import {ActionTypes, FetchPricePayload, PricingActionTypes, FetchPriceFulfilledPayload} from './types';
import {FailedRequestPayload} from '../types';

export const fetchPrice = (payload: FetchPricePayload): PricingActionTypes => {
  return {
    type: ActionTypes.FETCH_PRODUCT_PACKAGE_PRICES_PENDING,
    payload
  };
};

export const fetchPriceFulfilled = (payload: FetchPriceFulfilledPayload): PricingActionTypes => {
  return {
    type: ActionTypes.FETCH_PRODUCT_PACKAGE_PRICES_FULFILLED,
    payload
  };
};

export const fetchPriceRejected = (payload: FailedRequestPayload): PricingActionTypes => {
  return {
    type: ActionTypes.FETCH_PRODUCT_PACKAGE_PRICES_REJECTED,
    payload
  };
};
